/**
 * CalendarEventInventoryValidationError
 */
export enum CalendarEventInventoryValidationError {
    INACTIVE = 'INACTIVE',
    QUANTITY_NOT_ALLOWED = 'QUANTITY_NOT_ALLOWED',
    QUANTITY_MUST_BE_SET = 'QUANTITY_MUST_BE_SET',
    QUANTITY_LIMIT_REACHED = 'QUANTITY_LIMIT_REACHED',
    CAPACITY_LIMIT_REACHED = 'CAPACITY_LIMIT_REACHED',
    CAPACITY_MUST_BE_SET = 'CAPACITY_MUST_BE_SET'
}
